import { compact, uniq } from 'lodash';
export default function createQueryKey(basePath, variant, params = {}, rest = []) {
  const basePathWithVariant = variant.replace('/{id}', '').replace('{basePath}', basePath);
  return compact(uniq([basePath, params, basePathWithVariant, ...rest]));
}